// extracted by mini-css-extract-plugin
export default {"cookiesInfo":"style_cookiesInfo__C6K5B","buttons":"style_buttons__8JsWk"};